import { Box, Group, Paper, Text } from "@mantine/core"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * A single KPI tile — an uppercase caption, one headline figure (optionally with
 * a small unit suffix), and a secondary meta line that can hold a sublabel or a
 * status chip. Pure presentation, reusable across pages; the tone tints the
 * number via a WCAG-safe text anchor rather than a border bar. Given the same
 * props it renders identically.
 */
export const StatTile = ({ label, value, valueSuffix, meta, tone = "neutral", icon }: IProps): React.JSX.Element => (
  <Paper withBorder radius="md" p="md" className={classes.tile}>
    <Group gap={6} align="center" wrap="nowrap">
      {icon ? (
        <Box className={classes.icon} aria-hidden>
          {icon}
        </Box>
      ) : null}
      <Text size="xs" c="dimmed" tt="uppercase" fw={600} className={classes.label}>
        {label}
      </Text>
    </Group>

    <Group gap={6} align="baseline" wrap="nowrap" className={classes.valueRow}>
      <Text className={classes.value} data-tone={tone}>
        {value}
      </Text>
      {valueSuffix ? (
        <Text size="sm" c="dimmed" fw={600}>
          {valueSuffix}
        </Text>
      ) : null}
    </Group>

    {meta ? <Box className={classes.meta}>{meta}</Box> : null}
  </Paper>
)
